var React = require('react');

function MarsClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close Modal Button"),React.createElement("circle",{"cx":"32","cy":"32","r":"32","fill":"white","key":1}),React.createElement("rect",{"x":"22.1006","y":"19","width":"32","height":"4","rx":"1","transform":"rotate(45 22.1006 19)","fill":"#0000A0","key":2}),React.createElement("rect",{"x":"19.2725","y":"42","width":"32","height":"4","rx":"1","transform":"rotate(-45 19.2725 42)","fill":"#0000A0","key":3})]);
}

MarsClose.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = MarsClose;

MarsClose.default = MarsClose;
